/**
 * @generated SignedSource<<c60b4cdcb35ffcf99e9dac7ab120eb4d>>
 * @relayHash 25bb212fb9dcb165ca802d31818fab42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionContributorsQuery$variables = {
  versionId: string;
};
export type async_softwareReleasesVersionContributorsQuery$data = {
  readonly jira: {
    readonly version: {
      readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesLaunchCard_AsyncVersionContributors">;
    };
  };
};
export type async_softwareReleasesVersionContributorsQuery = {
  response: async_softwareReleasesVersionContributorsQuery$data;
  variables: async_softwareReleasesVersionContributorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "async_softwareReleasesVersionContributorsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "async_softwareReleasesLaunchCard_AsyncVersionContributors"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "async_softwareReleasesVersionContributorsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraVersionContributorConnection",
                    "kind": "LinkedField",
                    "name": "contributors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraVersionContributorEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "jobTitle"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AtlassianAccountUser"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraVersion"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b199f8523e8b333f650adf93ec0ebc73c3b0927f50a3fec2c9c3769918fbeb9b",
    "metadata": {},
    "name": "async_softwareReleasesVersionContributorsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0dd2c9bd66e5b70949d165995607196b";

export default node;
